
import React from "react";
import techer from "../../img/teche.PNG";
import "./Teacher.css";

const Teacher = () => {
    return (
    <>
<div className="teacher" id="teacher">   
      <header>
    
        <section className="container main-hero-container">
          <div className="row">
            <div className="col-12 col-lg-6 header-left-side d-flex justify-content-center 
            flex-column align-items-start ">
              <h1 className="display-2">
              Video In Live Action <br /> Easy For You.
              </h1>

              <p className="main-hero-para">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et,
                quia quis? Ipsa officia ad deserunt voluptate quam, nisi odio
                officiis tempora recusandae voluptate quam, nisi odio officiis
                tempora recusandae
              </p>
              <h3>want to know more?</h3>
              <a href="#" 
                    className="btn btn-outline-primary">Join us</a>
            </div>
            {/*  --------------- main header right side--------------  */}
            <div className="col-12 col-lg-6 header-right-side d-flex justify-content-center align-items-center main-herosection-images">
              <img
                src={techer}
                alt="heroimg"
                className="img-fluid"
              />
            
            </div>
          </div>
        </section>
      </header>
   
     
    
      </div> 
       
      
    </>
  );
};



export default Teacher;